import { useState } from 'react';
import { useAuth } from '../../context/authContext';
import { useNavigate } from 'react-router-dom';
import LOGO from '../../assets/york.png'
import './styles.css';

function NavBar() {
  const { user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky fixed-top z-50">
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/">
            <img src={LOGO} alt="Logo York" className="h-10" />
          </a>
        </div>

        {/* Desktop menu */}
        <nav className="hidden lg:flex space-x-6">
          <NavItem id="solicitacao" label="Novo Chamado" />
          <NavItem id="minhas-solicitacoes" label="Meus Chamados" />
          {Array.isArray(user.roles) && user.roles.includes("NPS") && (
            <NavItem id="nps/dashboard" label="NPS" href={true} />
          )}
          <NavItem id="dados" label="Minha Conta" />
        </nav>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-gray-800"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <i className="fas fa-bars text-2xl"></i>
        </button>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white w-full py-4 px-4 border-t">
          <div className="flex flex-col space-y-3">
            <NavItemMobile id="solicitacao" label="Novo Chamado" />
            <NavItemMobile id="minhas-solicitacoes" label="Meus Chamados" />
            {user.roles.includes("NPS") && < NavItemMobile id="nps/dashboard" label="NPS" href={true} />}
            <NavItemMobile id="dados" label="Minha Conta" />
          </div>
        </div>
      )}
    </header>
  );
}

export default NavBar;

const NavItem = (item, href) => {
  const navigate = useNavigate();

  const goTo = (id) => {
    if (href) {
      window.location.href = `/${id}`;
    } else {
      navigate(`/${id}`);
    }
  };

  return (
    <button
      key={item.id}
      onClick={() => goTo(item.id)}
      className={`text-gray-800 hover:text-indigo-600 font-medium ${window.location.pathname.includes(item.id) ? 'text-indigo-600' : ''
        }`}
    >
      {item.label}{' '}
      {item.icon && <i className={`${item.icon} ml-1 text-base`} />}
    </button>
  )
};

const NavItemMobile = (item, href) => {
  const navigate = useNavigate();

  const goTo = (id) => {
    if (href == true) {
      window.location.href = `/${id}`;
    } else {
      navigate(`/${id}`);
    }
  };

  return (
    <button
      key={item.id}
      onClick={() => goTo(item.id)}
      className={`text-left text-gray-800 hover:text-indigo-600 font-medium ${window.location.pathname.includes(item.id) ? 'text-indigo-600' : ''
        }`}
    >
      {item.label}{' '}
      {item.icon && <i className={`${item.icon} ml-1 text-base`} />}
    </button>
  )
};